import React from "react";

export const DashTagline = ({ titulo }) => {
  return (
    <div className="dash-vendedor-tagline">
      <div className="dash-vendedor-tagline-titulo">{titulo}</div>
    </div>
  );
};
